import React, { useState } from "react";
import Profile from "./Profile";
import OfficeTime from "./OfficeTime";
import TableActionContainer from "../../components/CustomTable/TableActionsContainer";
import { TabMenu } from "primereact/tabmenu";
import { CustomButton } from "../../components/CustomButton";

const UserProfile = () => {
  const [index, setIndex] = useState(0);
  const items = [
    {
      label: "Profile",
      icon: "",
      value: "profile",
    },
    // {
    //   label: "Set Office Hours",
    //   icon: "",
    //   value: "office-hrs",
    // },
  ];
  const handleTabChange = (e) => {
    setIndex(e.index);
  };

  return (
    <div>
      <div>
        <TableActionContainer>
          <div className="flex justify-content-between align-items-center flex-wrap gap-3">
            <div className="flex gap-2 align-items-end ">
              <TabMenu
                model={items} // Pass the entire item (not just label) as model
                activeIndex={index}
                onTabChange={handleTabChange}
                className="custom-tabmenu"
              />
            </div>

            <div className="flex gap-3 flex-wrap-reverse">
              <div className="flex gap-2 justify-content-end align-items-center flex-grow-1">
                <div className="flex gap-2">{/* button Space  */}</div>
              </div>
            </div>
          </div>
        </TableActionContainer>
      </div>
      {index === 0 ? <Profile /> : <OfficeTime />}
    </div>
  );
};

export default UserProfile;
